import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import SendDocuments from '@/views/SendDocuments.vue';
import AcademicFormation from '../views/studentData/AcademicFormation.vue';
import Contract from '../views/Contract.vue';
import EnrollmentResult from '../views/EnrollmentResult.vue';
import ValidateLogin from '../views/ValidateLogin.vue';
import VIEWS_NAMES from './viewsNames';
import stepRouteMapping from '@/pipeline/stepRouteMapping';
import pipeline from '@/pipeline';
import PersonalData from '../views/studentData/PersonalData.vue';
import PersonalDataFinancialSponsor from '../views/studentData/PersonalDataFinancialSponsor.vue';
import Payment from '@/views/Payment.vue';
import Accounts from '@/views/Accounts.vue';
import Address from '@/views/studentData/Address.vue';
import FinancialSponsorAddress from '@/views/studentData/FinancialSponsorAddress.vue';
import IdentificationDocument from '@/views/studentData/IdentificationDocument.vue';
import IdentificationDocumentFinancialSponsor from '@/views/studentData/IdentificationDocumentFinancialSponsor.vue';
import AccountsResult from '@/views/AccountsResult.vue';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { thankyoupageMiddleware, prouniMiddleware } from '@/router/middlewares';
import PROUNI_VIEWS_NAMES from './prouniViewsNames';
import ProuniStart from '@/views/prouni/ProuniStart.vue';
import ProuniPersonalData from '@/views/prouni/ProuniPersonalData.vue';
import ProuniPersonalDocuments from '@/views/prouni/ProuniPersonalDocuments.vue';
import ProuniResidence from '@/views/prouni/ProuniResidence.vue';
import ProuniFamilyIncome from '@/views/prouni/ProuniFamilyIncome.vue';
import ProuniEducation from '@/views/prouni/ProuniEducation.vue';
import ProuniAcceptance from '@/views/prouni/ProuniAcceptance.vue';
import ProuniAcompanhamento from '@/views/prouni/Acompanhamento.vue';
import ProuniNotEligible from '@/views/prouni/ProuniNotEligible.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    name: VIEWS_NAMES.PERSONAL_DATA,
    path: '/dados-pessoais',
    component: PersonalData,
  },
  {
    name: VIEWS_NAMES.ADDRESS,
    path: '/endereco',
    component: Address,
  },
  {
    name: VIEWS_NAMES.IDENTIFICATION_DOCUMENT,
    path: '/rg',
    component: IdentificationDocument,
  },
  { name: VIEWS_NAMES.ACADEMIC_FORMATION, path: '/formacao', component: AcademicFormation },
  {
    name: VIEWS_NAMES.FINANCIAL_SPONSOR_PERSONAL_DATA,
    path: '/dados-responsavel-financeiro',
    component: PersonalDataFinancialSponsor,
  },
  {
    name: VIEWS_NAMES.FINANCIAL_SPONSOR_IDENTIFICATION_DOCUMENT,
    path: '/rg-responsavel-financeiro',
    component: IdentificationDocumentFinancialSponsor,
  },
  {
    name: VIEWS_NAMES.FINANCIAL_SPONSOR_ADDRESS,
    path: '/endereco-responsavel-financeiro',
    component: FinancialSponsorAddress,
  },
  { name: VIEWS_NAMES.DOCUMENTS, path: '/documentos', component: SendDocuments },
  { name: VIEWS_NAMES.CONTRACT, path: '/contrato', component: Contract },
  { name: VIEWS_NAMES.PAYMENT, path: '/pagamento', component: Payment },
  {
    name: VIEWS_NAMES.RESULT,
    path: '/resultado',
    component: EnrollmentResult,
    meta: {
      middleware: thankyoupageMiddleware,
    },
  },
  { name: VIEWS_NAMES.VALIDATE_LOGIN, path: '/validar-login', component: ValidateLogin },
  { name: VIEWS_NAMES.ACCOUNTS, path: '/conta', component: Accounts },
  { name: VIEWS_NAMES.ACCOUNTS_RESULT, path: '/conta-resultado', component: AccountsResult },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_START,
    path: '/prouni',
    component: ProuniStart,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_NOT_ELIGIBLE,
    path: '/prouni/nao-elegivel',
    component: ProuniNotEligible,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_PERSONAL_DATA,
    path: '/prouni/dados-pessoais',
    component: ProuniPersonalData,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_PERSONAL_DOCUMENTS,
    path: '/prouni/documentos-pessoais',
    component: ProuniPersonalDocuments,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_RESIDENCE,
    path: '/prouni/residencia',
    component: ProuniResidence,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_FAMILY_INCOME,
    path: '/prouni/renda-familiar',
    component: ProuniFamilyIncome,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_EDUCATION,
    path: '/prouni/escolaridade',
    component: ProuniEducation,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_ACCEPTANCE,
    path: '/prouni/aceite',
    component: ProuniAcceptance,
    meta: { middleware: prouniMiddleware },
  },
  {
    name: PROUNI_VIEWS_NAMES.PROUNI_FOLLOW_UP,
    path: '/prouni/acompanhamento',
    component: ProuniAcompanhamento,
    meta: { middleware: prouniMiddleware },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

interface Context {
  from: any;
  next: Function;
  router: VueRouter;
  to: any;
}

function nextFactory(context: Context, middlewares: Function[], index: number) {
  const subsequentMiddleware = middlewares[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters: any[]) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middlewares, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to?.meta?.middleware) {
    const middlewares = Array.isArray(to?.meta?.middleware)
      ? to?.meta?.middleware
      : [to?.meta?.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middlewares, 1);

    const [currentMiddleware] = middlewares;

    return currentMiddleware({ ...context, next: nextMiddleware });
  }

  const isRouteOnStateMachine = Object.values(stepRouteMapping).includes(to.name || '');

  if (pipeline.initialized) {
    const stepRouteName = stepRouteMapping[pipeline.currentStep];

    if (stepRouteName === to.name) next();
    else {
      // Delegates back behavior to pipeline
      next(from.path);
      pipeline.prev();
    }
  } else if (isRouteOnStateMachine) {
    // TODO: change to a fallback route
    next('/');
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  if (router.app.$store) router.app.$store.dispatch(AnalyticsActions.PAGE_VIEW);
});

export default router;
